import __micros from '@/config/micros'
import { defineStore, getActivePinia } from 'pinia'
import { utils, Channel, piniaStoreModules } from 'frontendcommon-3'
import { Auth, dashboardKey } from '@/dashboards'
import { ref, unref } from 'vue'
const { getAsyncDataOnce } = utils.requestUtils

export const useMicros = defineStore('useMicros', () => {
  const micros = ref(__micros)
  const channel = new Channel()

  channel.onShellLoadMicro(({ detail }) => {
    loadMicro(detail)
  })

  const getToken = getAsyncDataOnce(async () => {
    const token = await Auth.getToken()
    return {
      [dashboardKey]: {
        access_token: token
      }
    }
  })

  async function loadMicro (microId) {
    let micro
    try {
      // Prepare tokens
      const tokens = await getToken.call()
      const shellConfigStore = piniaStoreModules.useShellConfig(getActivePinia())
      shellConfigStore.tokens = tokens
      // Find Micro
      micro = micros.value.find((micro) => micro.id === microId)
      if (!micro) throw new Error(`AppShell: loadMicro with invalid microId "${microId}". Micro NOT found`)
      const modules = await micro.load.call()
      micro.modules = modules
      window.dispatchEvent(new CustomEvent(`${micro.id}:loaded`, { detail: unref(micro) }))
      return modules
    } catch (err) {
      console.error(err)
      window.dispatchEvent(new CustomEvent(`${micro.id}:error`, { detail: err }))
      throw err
    }
  }

  return {
    micros,
    loadMicro,
    getToken
  }
})
